// @vendors
const Immutable = require('immutable');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_GO_TO_MY_WALLET,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    isEvaluationAccepted: false,
    isEvaluationAcceptedInvalid: false,
    continueOperationAcceptingResponsability: false,
    operateOmittingTest: false
});

function brokerConvenienceMiFIDTestStepSuccess(state = INITIAL_STATE, action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_GO_TO_MY_WALLET:
            return state; // @hardcoded
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE:
            return state.set('isEvaluationAcceptedInvalid', !state.get('isEvaluationAccepted'));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION:
            return state.set('continueOperationAcceptingResponsability', true);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION:
            return state.set('isEvaluationAccepted', action.payload.isEvaluationAccepted);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST:
            return state.set('operateOmittingTest', state.get('isEvaluationAccepted'));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT:
            return state; // @hardcoded
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStepSuccess;
